var common = require('./common')
var requestXHrTotals
  $('body').on('change paste keyup', '#amount-emballage, #amount-shipping', function(e) {
    var current_val = $(this).val()

    if ( current_val < 0 || current_val == '' )
    {
      $(this).val(0)
    }

    if (requestXHrTotals && requestXHrTotals.readyState != 4)
    {
      requestXHrTotals.abort()
    }

    requestXHrTotals = $.ajax({
      url: '/tunnel-adhesion/update/totals',
      data: {
        emballage: $('#amount-emballage').val(),
        shipping: $('#amount-shipping').val()
      },
      method: 'post',
      cache: false,
      dataType: 'json',
      success: function (data)
      {
        //$('#cartpage-cart-totals').html(data.totals)
        tunnel_getCartRecapHtml();
      },
      error: function (XMLHttpRequest, textStatus, errorThrown)
      {
        if ( errorThrown != 'abort' )
        {
          console.log(XMLHttpRequest);
          console.log(textStatus);
          console.log(errorThrown);
        }
      },
      complete: function(jqXHR, textStatus)
      {
        common.globalLoader(false)
      }
    })
  })
function tunnel_save_data (json_data) {
    $.ajax({
      url: '/tunnel-adhesion/save/data',
      data: {data:{json_data}},
      method: 'post',
      cache: false,
      dataType: 'json',
      success: function (data) { 
        console.log(data);
        
      },
      error: function (XMLHttpRequest, textStatus, errorThrown)
      {
        if ( errorThrown != 'abort' )
        {
          console.log(XMLHttpRequest);
          console.log(textStatus);
          console.log(errorThrown);
        }
      },
      complete: function(jqXHR, textStatus){
        tunnel_getCartRecapHtml();
      }
    })
  }
  function saveDiscountForAbonnementNid(nid,value) {
    $.ajax({
      url: '/tunnel-adhesion/save/data',
      data: {discount_abonnement:{'nid':nid,'value':value}},
      method: 'post',
      cache: false,
      dataType: 'json',
      success: function (data) { 
        console.log(data);
        
      },
      error: function (XMLHttpRequest, textStatus, errorThrown)
      {
        if ( errorThrown != 'abort' )
        {
          console.log(XMLHttpRequest);
          console.log(textStatus);
          console.log(errorThrown);
        }
      },
      complete: function(jqXHR, textStatus){
        tunnel_getCartRecapHtml();
      }
    })
  }
  function tunnel_getCartRecapHtml() {
    $("#cartpage-cart-body").html('');
    //common.globalLoader(true);
    $.ajax({
      url: '/tunnel-adhesion/getcartproductsfromsession',
      method: 'post',
      cache: false,
      data: {data:{}},
      dataType: 'json',
      success: function (data) { 
        //console.log(data);
        $("#cartpage-cart-body").html(data.html);
        $("#cartpage-cart-totals").html(data.total);
      },
      error: function (XMLHttpRequest, textStatus, errorThrown)
      {
        if ( errorThrown != 'abort' )
        {
          console.log(XMLHttpRequest);
          console.log(textStatus);
          console.log(errorThrown);
        }
      },
      complete: function(jqXHR, textStatus)
      {
        //common.globalLoader(false)
      }
    })   
  }
  $('#block-views-block-my-summary-adhesion-block-1').on('click','.btn-goto-tunnel-adhesion-step-6',function (e) {
    e.preventDefault()
    common.globalLoader(true);
  
    var requestXHr   = $.ajax({
      url: '/tunnel-adhesion/finalizesessioncart',
      method: 'post',
      data: {},
      cache: false,
      dataType: 'json',
      success: function (data)
      {
        if ( data )
        { 
          //console.log(data);
          window.location.href = data.redirect_to
        }
      },
      error: function (XMLHttpRequest, textStatus, errorThrown)
      {
        if ( errorThrown != 'abort' )
        {
          console.log(XMLHttpRequest);
          console.log(textStatus);
          console.log(errorThrown);
        }
      },
      complete: function(jqXHR, textStatus)
      {
        //common.globalLoader(false)
      }
    })
  });

$('.checkbox-adhesion').each(function(){
    var is_eu = $('body').hasClass('france');
    var is_fr = $('body').hasClass('europe');
    var not_eu = $('body').hasClass('non_europe');
    var target_data_price = 'prixeu';
    if(is_fr) {
      target_data_price = 'prixfr';
    }
    if(not_eu) {
      target_data_price = 'prixnoteu';
    }
    var nid  = $(this).data('nid');
    var type  = $(this).data('type');
    var prix  = $(this).data(target_data_price);
    console.log(target_data_price);
    console.log(prix);
    $(this).siblings('div.prix').html('<span class="field_price">'+prix+'€</span>');
    var support  = $(this).data('support');
    var codeachat  = $(this).data('codeachat');
    $(this).html('<input type="checkbox" name="input-adhesion" class="checkbox-adhesion-item" data-prix="'+prix+'" data-codeachat="'+codeachat+'" data-support="'+support+'" data-type="'+type+'" data-nid="'+nid+'" id="checkbox-'+nid+'" value="'+nid+'">');
});
$('.checkbox-adhesion-ems').each(function(){
  var nid  = $(this).data('nid');
  var type  = $(this).data('type');
  var prix  = $(this).data('prix');
  var support  = $(this).data('support');
  var codeachat  = $(this).data('codeachat');
  $(this).html('<input type="checkbox" name="input-adhesion-ems" class="checkbox-adhesion-ems-item" data-prix="'+prix+'" data-codeachat="'+codeachat+'" data-support="'+support+'" data-type="'+type+'" data-nid="'+nid+'" id="checkbox-'+nid+'" value="'+nid+'">');
});

var aboheader = '<div class="row abonnement_header" id="abonnement_header"><div class="col-sm-2"><span class="prix_electronic_fr">@</span></div><div class="col-sm-2"><span class="glyphicon glyphicon-book">+@</span></div><div class="col-sm-1">Remise</div><div class="col-sm-7">Abonnements</div></div>';
$(aboheader).insertAfter('#views-exposed-form-tunnel-administrateur-block-2');

$('.input-abo').each(function(){
    var nid  = $(this).data('nid');
    var field  = $(this).data('field');
    var type  = $(this).data('type');
    var prix  = $(this).data('prix');
    var support  = $(this).data('support');
    var codeachat  = $(this).data('codeachat');
    $(this).html('<input type="checkbox" name="input-abonnement" class="checkbox-abonnement-item" data-prix="'+prix+'" data-codeachat="'+codeachat+'" data-support="'+support+'" data-type="'+type+'" data-field="'+field+'" data-nid="'+nid+'" id="checkbox-'+nid+'" value="'+nid+'">');
});
var abosupheader = '<div class="row abonnement_supplement_header" id="abonnement_supplement_header"><div class="col-sm-2"><span class="glyphicon glyphicon-book"></span></div><div class="col-sm-1">Remise</div><div class="col-sm-9">Suppléments papier</div></div>';  
$(abosupheader).insertAfter('#views-exposed-form-tunnel-administrateur-block-3');
$('.input-abo_suppl').each(function(){
  var nid  = $(this).data('nid');
  var field  = $(this).data('field');
  var type  = $(this).data('type');
  var prix  = $(this).data('prix');
  var support  = $(this).data('support');
  var codeachat  = $(this).data('codeachat');
  $(this).html('<input type="checkbox" name="input-abonnement_supplement" class="checkbox-abonnement_supplement-item" data-prix="'+prix+'" data-codeachat="'+codeachat+'" data-support="'+support+'" data-type="'+type+'" data-field="'+field+'" data-nid="'+nid+'" id="checkbox-'+nid+'" value="'+nid+'">');
});
$('.select-discount_wrapper').each(function(){
  var nid  = $(this).data('nid');
  $(this).html('<select id="select-abonnement-discount-'+nid+'" data-nid="'+nid+'"  name="select-abonnement-discount-'+nid+'" class="select-abonnement-discount">  <option value="0" selected="true">0%</option>  <option value="12">12%</option>  <option value="15" >15%</option>  <option value="30">30%</option>  <option value="50">50%</option>  <option value="100">100%</option></select>');
});
$('input[type=checkbox]').on('click',function(){
    var nid = $(this).data('nid');
    var type = $(this).data('type');
    var prix = $(this).data('prix');
    var support = $(this).data('support');
    var id = $(this).attr('id');
    var qty = 1; 
    var discount = 0;
    var discount_price = 0;
    
    if($(this).hasClass('checkbox-adhesion-item')){
      var $body = $('body');
      if($body.hasClass('non_adherent')) {
        $body.removeClass("non_adherent");
        $body.addClass("adherent");
      }
      $('.checkbox-adhesion-item').each(function(){
          if( $(this).attr('id') != id ) { 
              $(this).prop('checked',false) ;
          }
      });
    }
    var formattedString = nid + '|' + support + '|' +prix + '|' +qty + '|' +discount + '|' +discount_price;
    tunnel_save_data({[type]:formattedString});
    //tunnel_getCartRecapHtml();

});

$("#valider_dons").on('click',function(e){
    e.preventDefault();
    var don_smf = $('#don_smf_amount').val();
    var don_cimpa = $('#don_cimpa_amount').val();
    var don_libre_code = $('#don_libre_code').val();
    var don_libre_amount = $('#don_libre_amount').val();
    tunnel_save_data({'don_smf':don_smf,'don_cimpa':don_cimpa,'don_libre_code':don_libre_code,'don_libre_amount':don_libre_amount});
    tunnel_getCartRecapHtml();
    
});

$('#validerselection').on('click',function(e){
  e.preventDefault();
  console.log('l160');
  tunnel_getCartRecapHtml();
});
$('#client-search-numorder').on("focusout",function(){
  tunnel_save_data({
    'numorder':$(this).val()
  });
});
$('#client-search-modepayment').on("change",function(){
  tunnel_save_data({
    'payment_type':$(this).val()
  });
})
$('#resetCartSessionBtn').on('click',function(){
  common.globalLoader(true)
  $.ajax({
    url: '/tunnel-adhesion/resetcartsession',
    method: 'post',
    cache: false,
    dataType: 'json',
    success: function (data) { 
      console.log(data);
      if(data.redirect_to.length >0 ) location.href = data.redirect_to;
    },
    error: function (XMLHttpRequest, textStatus, errorThrown)
    {
      if ( errorThrown != 'abort' )
      {
        console.log(XMLHttpRequest);
        console.log(textStatus);
        console.log(errorThrown);
      }
    }
  })
});
$('body').on('click', '.cart-controls-tunnelonepage-adhesion-delete', function(e) {
  e.preventDefault();
  var $this   = $(this)
  var pid     = $this.data('pid')
  var pos     = $this.data('pos')
  var variable     = $this.data('variable')
  var $target = $('#product-' + pid + '-' + $this.data('type'))
  $target.fadeOut('slow');
  $.ajax({
    url: '/tunnel-adhesion/removecartproductsfromsession',
    method: 'post',
    cache: false,
    data: {data:{'nid':this.dataset.pid,'variable':variable}},
    dataType: 'json',
    success: function (data) { 
      //console.log(data);
      tunnel_getCartRecapHtml();
      
    },
    error: function (XMLHttpRequest, textStatus, errorThrown)
    {
      if ( errorThrown != 'abort' )
      {
        console.log(XMLHttpRequest);
        console.log(textStatus);
        console.log(errorThrown);
      }
    }
  })
})
$('body').on('click', '.btn-add-product-tunnel-adhesion', function(e) {
  e.preventDefault()

  var nid = $('#tunnel_adhesion__add_product-input-nid').val()
  
  if ( nid != '' )
  {
    //common.globalLoader(true)
    var uds = $('.tunnel_adhesion__add_product-cart-controls .cart-controls-qty').val()
    var dto = $('#tunnel_adhesion__add_product-discount').val()

    tunnel_save_data({'publication':nid+'|ep||'+uds+'|'+dto});
    //common.globalLoader(false)
    //tunnel_getCartRecapHtml();
  }
  else
  {
    $.notify({
      message: Drupal.t('Vous devez sélectionner un produit.')
    },{
      z_index: 2000,
      allow_dismiss: false,
      type: 'danger'
    })
  }
})

$('body').on('change', '.select-abonnement-discount', function() {
  console.log(this);
  var nid = $(this).data('nid');
  var value = $(this).val();
  saveDiscountForAbonnementNid(nid,value);
  
});

$('body').on('click', 'a.scrollto', function() {
if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'')
    && location.hostname == this.hostname) {
        var $target = $(this.hash);
        $target = $target.length && $target || $('[name=' + this.hash.slice(1) +']');
        if ($target.length) {
          var targetOffset = $target.offset().top - 200;
          $('html,body').animate({scrollTop: targetOffset}, 500);
          
        }
    }
});

$('body').on('click','#checkbox-csv',function(){
  var status = $('#checkbox-csv').is(':checked')
  console.log(status);
  if(!status) {
    //$('#checkbox-csv').data('disable_sage_export',true);
    tunnel_save_data({'disable_sage_export':false});
  } else { 
    //$('#checkbox-csv').data('disable_sage_export',false);
    tunnel_save_data({'disable_sage_export':true});
  }
  
});

//drupal behaviors

(function ($) {
  Drupal.behaviors.exposedFilters = {
    attach: function(context, settings) {

      $(document).once('.change-detector-adh').ajaxComplete(function (e, xhr, settings) {
        // ...
        
        if(settings.type == "POST" && settings.url ==  "/views/ajax?_wrapper_format=drupal_ajax") {
          /** repopulate checkbox behavior */
          $('.checkbox-adhesion').each(function(){
            var nid  = $(this).data('nid');
            var type  = $(this).data('type');
            var prix  = $(this).data('prix');
            var support  = $(this).data('support');
            var codeachat  = $(this).data('codeachat');
            $(this).html('<input type="checkbox" name="input-adhesion" class="checkbox-adhesion-item" data-prix="'+prix+'" data-codeachat="'+codeachat+'" data-support="'+support+'" data-type="'+type+'" data-nid="'+nid+'" id="checkbox-'+nid+'" value="'+nid+'">');
        });
        $('.checkbox-adhesion-ems').each(function(){
          var nid  = $(this).data('nid');
          var type  = $(this).data('type');
          var prix  = $(this).data('prix');
          var support  = $(this).data('support');
          var codeachat  = $(this).data('codeachat');
          $(this).html('<input type="checkbox" name="input-adhesion-ems" class="checkbox-adhesion-ems-item" data-prix="'+prix+'" data-codeachat="'+codeachat+'" data-support="'+support+'" data-type="'+type+'" data-nid="'+nid+'" id="checkbox-'+nid+'" value="'+nid+'">');
        });
        
        
        
        $('.select-discount_wrapper').each(function(){
          var nid  = $(this).data('nid');
          $(this).html('<select id="select-abonnement-discount-'+nid+'" data-nid="'+nid+'"  name="select-abonnement-discount-'+nid+'" class="select-abonnement-discount">  <option value="0" selected="true">0%</option>  <option value="12">12%</option>  <option value="15" >15%</option>  <option value="30">30%</option>  <option value="50">50%</option>  <option value="100">100%</option></select>');
        });
        $('input[type=checkbox]').on('click',function(){
            var nid = $(this).data('nid');
            var type = $(this).data('type');
            var prix = $(this).data('prix');
            var support = $(this).data('support');
            var id = $(this).attr('id');
            var qty = 1; 
            var discount = 0;
            var discount_price = 0;
            
            if($(this).hasClass('checkbox-adhesion-item')){
              var $body = $('body');
              if($body.hasClass('non_adherent')) {
                $body.removeClass("non_adherent");
                $body.addClass("adherent");
              }
              $('.checkbox-adhesion-item').each(function(){
                  if( $(this).attr('id') != id ) { 
                      $(this).prop('checked',false) ;
                  }
              });
            }
            var formattedString = nid + '|' + support + '|' +prix + '|' +qty + '|' +discount + '|' +discount_price;
            tunnel_save_data({[type]:formattedString});
            //tunnel_getCartRecapHtml();
        
        });  
        }
        }); 


      $(document).once('.change-detector-abo').ajaxComplete(function (e, xhr, settings) {
      // ...
      
      if(settings.type == "POST" && settings.url ==  "/views/ajax?_wrapper_format=drupal_ajax") {
        var container = $('#abonnement_header');
        
        if(container.length < 1) {
          var aboheader = '<div class="row abonnement_header" id="abonnement_header"><div class="col-sm-2"><span class="prix_electronic_fr">@</span></div><div class="col-sm-2"><span class="glyphicon glyphicon-book">+@</span></div><div class="col-sm-2">Remise</div><div class="col-sm-6">Abonnements</div></div>';  
          $(aboheader).insertAfter('#views-exposed-form-tunnel-administrateur-block-2');
          
        } 
        
       
        
        $('.input-abo').each(function(){
            var nid  = $(this).data('nid');
            var field  = $(this).data('field');
            var type  = $(this).data('type');
            var prix  = $(this).data('prix');
            var support  = $(this).data('support');
            var codeachat  = $(this).data('codeachat');
            $(this).html('<input type="checkbox" name="input-abonnement" class="checkbox-abonnement-item" data-prix="'+prix+'" data-codeachat="'+codeachat+'" data-support="'+support+'" data-type="'+type+'" data-field="'+field+'" data-nid="'+nid+'" id="checkbox-'+nid+'" value="'+nid+'">');
        });
        $('input[type=checkbox]').on('click',function(){
          var nid = $(this).data('nid');
          var type = $(this).data('type');
          var prix = $(this).data('prix');
          var support = $(this).data('support');
          var id = $(this).attr('id');
          var qty = 1; 
          var discount = 0;
          var discount_price = 0;
          
          if($(this).hasClass('checkbox-adhesion-item')){
            var $body = $('body');
            if($body.hasClass('non_adherent')) {
              $body.removeClass("non_adherent");
              $body.addClass("adherent");
            }
            $('.checkbox-adhesion-item').each(function(){
                if( $(this).attr('id') != id ) { 
                    $(this).prop('checked',false) ;
                }
            });
          }
          var formattedString = nid + '|' + support + '|' +prix + '|' +qty + '|' +discount + '|' +discount_price;
          tunnel_save_data({[type]:formattedString});
          //tunnel_getCartRecapHtml();
      
      }); 

      
      $('.select-discount_wrapper').each(function(){
        var nid  = $(this).data('nid');
        $(this).html('<select id="select-abonnement-discount-'+nid+'" data-nid="'+nid+'" name="select-abonnement-discount-'+nid+'" class="select-abonnement-discount">  <option value="0" selected="true">0%</option>  <option value="12">12%</option>  <option value="15" >15%</option>  <option value="30">30%</option>  <option value="50">50%</option>  <option value="100">100%</option></select>');
      });
      }
      
      }); 

      $(document).once('.change-detector-supl').ajaxComplete(function (e, xhr, settings) {
        // ...
       
        if(settings.type == "POST" && settings.url ==  "/views/ajax?_wrapper_format=drupal_ajax") {
          var container = $('#abonnement_supplement_header');
        if(container.length < 1) {
          var abosupheader = '<div class="row abonnement_supplement_header" id="abonnement_supplement_header"><div class="col-sm-2"><span class="glyphicon glyphicon-book"></span></div><div class="col-sm-2">Remise</div><div class="col-sm-8">Suppléments papier</div></div>';  
          $(abosupheader).insertAfter('#views-exposed-form-tunnel-administrateur-block-3');
        } 
  
        
        $('.input-abo_suppl').each(function(){
          var nid  = $(this).data('nid');
          var field  = $(this).data('field');
          var type  = $(this).data('type');
          var prix  = $(this).data('prix');
          var support  = $(this).data('support');
          var codeachat  = $(this).data('codeachat');
          $(this).html('<input type="checkbox" name="input-abonnement_supplement" class="checkbox-abonnement_supplement-item" data-prix="'+prix+'" data-codeachat="'+codeachat+'" data-support="'+support+'" data-type="'+type+'" data-field="'+field+'" data-nid="'+nid+'" id="checkbox-'+nid+'" value="'+nid+'">');
        });
        $('input[type=checkbox]').on('click',function(){
          var nid = $(this).data('nid');
          var type = $(this).data('type');
          var prix = $(this).data('prix');
          var support = $(this).data('support');
          var id = $(this).attr('id');
          var qty = 1; 
          var discount = 0;
          var discount_price = 0;
          
          if($(this).hasClass('checkbox-adhesion-item')){
            var $body = $('body');
            if($body.hasClass('non_adherent')) {
              $body.removeClass("non_adherent");
              $body.addClass("adherent");
            }
            $('.checkbox-adhesion-item').each(function(){
                if( $(this).attr('id') != id ) { 
                    $(this).prop('checked',false) ;
                }
            });
          }
          var formattedString = nid + '|' + support + '|' +prix + '|' +qty + '|' +discount + '|' +discount_price;
          tunnel_save_data({[type]:formattedString});
          //tunnel_getCartRecapHtml();
      
      }); 
        $('.select-discount_wrapper').each(function(){
          var nid  = $(this).data('nid');
          $(this).html('<select id="select-abonnement-discount-'+nid+'" data-nid="'+nid+'" name="select-abonnement-discount-'+nid+'" class="select-abonnement-discount">  <option value="0" selected="true">0%</option>  <option value="12">12%</option>  <option value="15" >15%</option>  <option value="30">30%</option>  <option value="50">50%</option>  <option value="100">100%</option></select>');
        });
        }
        
        }); 
      
      
    }
  }
})(jQuery);




// WEBPACK FOOTER //
// ./js/adhesion_onepage.js